'use client'

import { useAction } from 'next-safe-action/hooks'

import { signUp as _signUp } from '@/entities/auth'
import { JoinType, TSignUp, TSignUpResponse } from '@/entities/auth'
import { useAirbridgeContext } from '@/shared/config'
import { useServerErrorHandler } from '@/shared/config/action'
import { signInWithToken } from '@/shared/lib'

export const useSignUp = ({
  joinType,
  onSuccess,
}: {
  joinType: JoinType
  onSuccess: (data: TSignUpResponse) => void
}) => {
  const { handleServerError } = useServerErrorHandler()

  const { sendEvent } = useAirbridgeContext()

  const sendAirbridgeEvent = (data: TSignUpResponse) => {
    const { airbridgeData } = data

    const params = {
      action: airbridgeData.action,
      label: airbridgeData.label,
      value: airbridgeData.value,
    }

    sendEvent({
      event: airbridgeData.event_name,
      params,
      onSuccess: () => {
        onSuccess(data)
      },
    })
  }

  const action = useAction(_signUp, {
    onSuccess: async ({ data }) => {
      if (data) {
        sendAirbridgeEvent(data)
        await signInWithToken(data.firebaseToken)
      }
    },
    onError: ({ error }) => {
      if (error.serverError) {
        handleServerError(error.serverError)
      }
    },
  })

  const signUp = (data: TSignUp) => {
    action.execute({ joinType, body: data })
  }

  return { signUp }
}
